import './App.scss';

import useDfpSlot from './components/useDfpSlot';

import Header from './components/Header';
import Title from './components/Title';
import Posts from './components/Posts';
import Banner from './components/Banner';
import Panel from './components/Panel';
import Credit from './components/Credit';
import Footer from './components/Footer';


function App() {
  useDfpSlot({
    path: '/6674/stuff.shorthand/temaramatanga',
    id: `div-gpt-ad-8564960-102`,
  });
  // var triggerDate = "2022-04-29T01:00:00+13:00"
  // var today = new Date();
  // var styleTrigger;
  // if (new Date(triggerDate) - today < 0) {
  //   styleTrigger = 'hide'
  // }else{
  //   styleTrigger = ''
  // }
  return (
    <div className="App">
     <Header />
     {/* <div className={`hidediv ${styleTrigger}`}>
       <div>
        <img className="hidediv--logo" src={Logo} alt="the whole truth te marmatanga logo"/>
        <span>Coming April 29</span>
       </div>
      
     </div> */}
     <Title />
     {/* google ads */}
      {/* ads start */}
      <div className='ads-wrap-container'>
      <div id='div-gpt-ad-8564960-102'>
      </div>
      </div>
      {/* ads end */}
      {/* google ads */}
     <Posts />
     <Banner text={`Get the latest from The Whole Truth direct to your inbox`} ctaword={`Sign up for free`} ctalink={`https://my.stuff.co.nz/register/newsletter?type=thewholetruth`} />
     <Panel />
     <Banner text={`You can reach the reporters and editors on The Whole Truth project via email`} ctaword={`factcheck@stuff.co.nz`} ctalink={`factcheck@stuff.co.nz`} />
     <Credit />
     <Footer />
    </div>
  );
}

export default App;
